import { getUA } from './use-web-rtc'

export const stop = (): void => {
  getUA()?.stop()
}
